module.exports = __webpack_public_path__ + "static/img/3.50da728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.jpg
// module id = 89
// module chunks = 2